<template>
  <div class="landing-page">
    <img
      class="landing-image"
      src="@/assets/landing-poster.jpg"
      alt="蒲缇烘焙"
      @click="goToLogin"
    />
  </div>
</template>

<script>
export default {
  name: 'Landing',
  methods: {
    goToLogin() {
      // 落地页对应蒲缇烘焙商户（merchantId=14），点击图片直接带上商户ID跳登录页，
      // 登录页 mounted() 会读取 query.merchantid 并落盘到 localStorage（见 login.vue）
      this.$router.push('/login?merchantid=14')
    }
  }
}
</script>

<style lang="scss" scoped>
.landing-page {
  width: 100%;
  min-height: 100vh;
  background: #f5ede0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.landing-image {
  width: 100%;
  max-width: 100%;
  display: block;
  cursor: pointer;
}
</style>
